import script from "./ReportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportForm.vue?vue&type=script&setup=true&lang=js"

import "./ReportForm.vue?vue&type=style&index=0&id=398d3e8c&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398d3e8c"]])

export default __exports__